const overrides = {
  root: {
    padding: 24,
  },
};

export default overrides;
